import React, { useState } from "react";
import { getCsvResponse } from "api/loginRoutes";
import { downloadDataAsFile } from "utils";
import { ButtonPrimary } from "components/base/BaseButton";


export default () => {
    const [loading, setLoading] = useState(false);

    const downloadAuthNumbers = () => {
        setLoading(true);
        getCsvResponse("e164:get_list")
            .then((response) => {
                downloadDataAsFile(response, "E164.csv")
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <ButtonPrimary
            loading={loading}
            onClick={downloadAuthNumbers}
        >
            Download
        </ButtonPrimary>
    );
};